import {Component, Inject, InjectionToken, Injector, OnInit, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from "@angular/common";
import { RESPONSE } from '@nguniversal/express-engine/tokens';

@Component({
  selector: 'app-notfound',
  templateUrl: './notfound.component.html',
  styleUrls: ['./notfound.component.scss']
})
export class NotfoundComponent implements OnInit {

  constructor(@Inject(PLATFORM_ID) private platformId: InjectionToken<object>,
              private injector: Injector) { }

  ngOnInit(): void {
    if (isPlatformServer(this.platformId)) {
      const response: any = this.injector.get(RESPONSE);
      response.status(404);
    }
  }

}
